import { render } from "./AppSnackbar.vue?vue&type=template&id=d66cd5e6"
import script from "./AppSnackbar.vue?vue&type=script&lang=js"
export * from "./AppSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__